// extracted by mini-css-extract-plugin
module.exports = {"body":"statusgame_body__1o3xc","textPass":"statusgame_textPass__1wcFD","textSuccess":"statusgame_textSuccess__2_7gh","textFailed":"statusgame_textFailed__3kqwM"};